/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navtitles_Helpcentre2Inputs */

const en_navtitles_helpcentre2 = /** @type {(inputs: Navtitles_Helpcentre2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help Centre`)
};

/**
* | output |
* | --- |
* | "Help Centre" |
*
* @param {Navtitles_Helpcentre2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const navtitles_helpcentre2 = /** @type {((inputs?: Navtitles_Helpcentre2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navtitles_Helpcentre2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_navtitles_helpcentre2(inputs)
});
export { navtitles_helpcentre2 as "navTitles_helpCentre" }